"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateStatusFieldValue = exports.getStatusFieldEmptyValue = void 0;
const getStatusFieldEmptyValue = () => {
    return { value: "", updated_on: null };
};
exports.getStatusFieldEmptyValue = getStatusFieldEmptyValue;
/**
 * Generate a StatusFieldValue
 * @param value
 */
const generateStatusFieldValue = (value) => {
    return { ...(0, exports.getStatusFieldEmptyValue)(), ...value };
};
exports.generateStatusFieldValue = generateStatusFieldValue;
